export class SessionStorageConstants {
  static LOGIN_CREDENTIALS = 'loginCredentials';
}
